import {ICheckboxGroupOption} from "@pg-design/checkbox-module";

const baseQuestionsOptions = [
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "warunki", label: "Warunki rezerwacji i zakupu"},
    {value: "czynsz", label: "Czynsz i opłaty eksploatacyjne"},
    {value: "postoj", label: "Cenę miejsc postojowych"},
    {value: "wykon", label: "Koszt wykończenia pod klucz"},
    {value: "standard", label: "Standard wykończenia"},
    {value: "prosp", label: "Prospekt informacyjny"}
];

const moreQuestionsOptions = [
    {value: "zabez", label: "Zabezpieczenie transakcji"},
    {value: "harmon", label: "Harmonogramy płatności"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "inny", label: "Inny temat"}
];

export const applicationBaseCheckboxesOptions: ICheckboxGroupOption[] = baseQuestionsOptions.map((option) => ({
    value: option.value,
    labelContent: option.label
}));

export const applicationMoreCheckboxesOptions: ICheckboxGroupOption[] = moreQuestionsOptions.map((option) => ({
    value: option.value,
    labelContent: option.label
}));
import {ICheckboxGroupOption} from "@pg-design/checkbox-module";

const baseQuestionsOptions = [
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "warunki", label: "Warunki rezerwacji i zakupu"},
    {value: "czynsz", label: "Czynsz i opłaty eksploatacyjne"},
    {value: "postoj", label: "Cenę miejsc postojowych"},
    {value: "wykon", label: "Koszt wykończenia pod klucz"},
    {value: "standard", label: "Standard wykończenia"},
    {value: "prosp", label: "Prospekt informacyjny"}
];

const moreQuestionsOptions = [
    {value: "zabez", label: "Zabezpieczenie transakcji"},
    {value: "harmon", label: "Harmonogramy płatności"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "inny", label: "Inny temat"}
];

export const applicationBaseCheckboxesOptions: ICheckboxGroupOption[] = baseQuestionsOptions.map((option) => ({
    value: option.value,
    labelContent: option.label
}));

export const applicationMoreCheckboxesOptions: ICheckboxGroupOption[] = moreQuestionsOptions.map((option) => ({
    value: option.value,
    labelContent: option.label
}));
